export function stampMode(modes, data) {
  modes.forEach((m) => {
    const list =
      m === "personal_services" ? data.personal_services?.services :
      m === "class_based"       ? data.class_based?.classes :
      m === "accommodation"     ? data.accommodation?.room_types :
      m === "modular_seating"   ? data.modular_seating :
      [];
    (list ?? []).forEach((o) => { if (!o.mode) o.mode = m; });
  });

  // Also stamp mode on bundles
  if (Array.isArray(data.bundles)) {
    data.bundles.forEach((b) => {
      if (!b.mode) b.mode = "bundles";
    });
  }
}
